import { BrowserRouter, Routes, Route } from "react-router-dom";
import { lazy, Suspense } from "react";
import Landing from "./pages/Landing";
import LoadingSparkle from "./components/LoadingSparkle";

const Welcome = lazy(() => import("./pages/Welcome"));
const Create = lazy(() => import("./pages/Create"));
const Quiz = lazy(() => import("./pages/Quiz"));
const Generating = lazy(() => import("./pages/Generating"));
const Meet = lazy(() => import("./pages/Meet"));
const Home = lazy(() => import("./pages/Home"));
const Scene = lazy(() => import("./pages/Scene"));
const Drop = lazy(() => import("./pages/Drop"));
const Memories = lazy(() => import("./pages/Memories"));
const Family = lazy(() => import("./pages/Family"));
const Settings = lazy(() => import("./pages/Settings"));
const Upgrade = lazy(() => import("./pages/Upgrade"));
const CheckoutReturn = lazy(() => import("./pages/CheckoutReturn"));
const Story = lazy(() => import("./pages/Story"));
const Chat = lazy(() => import("./pages/Chat"));
const Studio = lazy(() => import("./pages/Studio"));
const AgeGate = lazy(() => import("./pages/AgeGate"));
const ParentConsent = lazy(() => import("./pages/ParentConsent"));
const ConsentPending = lazy(() => import("./pages/ConsentPending"));
const ConsentVerify = lazy(() => import("./pages/ConsentVerify"));
const Privacy = lazy(() => import("./pages/Privacy"));
const Terms = lazy(() => import("./pages/Terms"));
const Safety = lazy(() => import("./pages/Safety"));
const Parent = lazy(() => import("./pages/Parent"));
const ParentDrops = lazy(() => import("./pages/ParentDrops"));
const ParentReminders = lazy(() => import("./pages/ParentReminders"));
const ParentSettings = lazy(() => import("./pages/ParentSettings"));
const ArcVideo = lazy(() => import("./pages/ArcVideo"));
const RecapLetter = lazy(() => import("./pages/RecapLetter"));
const Postcard = lazy(() => import("./pages/Postcard"));
const InstallPrompt = lazy(() => import("./components/InstallPrompt"));
const ShareDrop = lazy(() => import("./pages/ShareDrop"));
const ShareWanderling = lazy(() => import("./pages/ShareWanderling"));
const Crossover = lazy(() => import("./pages/Crossover"));
const Try = lazy(() => import("./pages/Try"));
const SmsOptIn = lazy(() => import("./pages/SmsOptIn"));
const Signup = lazy(() => import("./pages/Signup"));
const Login = lazy(() => import("./pages/Login"));
const KidLogin = lazy(() => import("./pages/KidLogin"));
const PickUsername = lazy(() => import("./pages/PickUsername"));
const InviteAccept = lazy(() => import("./pages/InviteAccept"));
const JoinCircle = lazy(() => import("./pages/JoinCircle"));

export default function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<LoadingSparkle message="Loading..." />}>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/get-started" element={<Welcome />} />
          <Route path="/try" element={<Try />} />
          <Route path="/create" element={<Create />} />
          <Route path="/quiz" element={<Quiz />} />
          <Route path="/generating" element={<Generating />} />
          <Route path="/meet/:wanderlingId" element={<Meet />} />
          <Route path="/home" element={<Home />} />
          <Route path="/story/:arcId" element={<Story />} />
          <Route path="/scene/:sceneId" element={<Scene />} />
          <Route path="/drop/:dropId" element={<Drop />} />
          <Route path="/chat" element={<Chat />} />
          <Route path="/studio" element={<Studio />} />
          <Route path="/age-gate" element={<AgeGate />} />
          <Route path="/parent-consent" element={<ParentConsent />} />
          <Route path="/consent-pending" element={<ConsentPending />} />
          <Route path="/consent/verify/:token" element={<ConsentVerify />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/safety" element={<Safety />} />
          <Route path="/memories" element={<Memories />} />
          <Route path="/family" element={<Family />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/upgrade" element={<Upgrade />} />
          <Route path="/checkout/return" element={<CheckoutReturn />} />
          <Route path="/parent" element={<Parent />} />
          <Route path="/parent/drops" element={<ParentDrops />} />
          <Route path="/parent/reminders" element={<ParentReminders />} />
          <Route path="/parent/settings" element={<ParentSettings />} />
          <Route path="/arc/:arcId/video" element={<ArcVideo />} />
          <Route path="/recap/:letterId" element={<RecapLetter />} />
          <Route path="/postcard/:postcardId" element={<Postcard />} />
          <Route path="/share/:dropId" element={<ShareDrop />} />
          <Route path="/friend/:wanderlingId" element={<ShareWanderling />} />
          <Route path="/crossover/:crossoverId" element={<Crossover />} />
          <Route path="/sms-opt-in" element={<SmsOptIn />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/parent-signup" element={<Signup />} />
          <Route path="/login" element={<Login />} />
          <Route path="/kid-login" element={<KidLogin />} />
          <Route path="/pick-username" element={<PickUsername />} />
          <Route path="/invite/:token" element={<InviteAccept />} />
          <Route path="/join/:code" element={<JoinCircle />} />
          <Route path="/join" element={<JoinCircle />} />
        </Routes>
        <InstallPrompt />
      </Suspense>
    </BrowserRouter>
  );
}
